<template>
  <transition
    name="slide-in-down"
    :appear="appear"
    :duration="duration"
    v-bind="$attrs"
  >
    <slot />
  </transition>
</template>

<script lang="ts" setup>
defineProps({
  /**
   * Apply the transition on component's initial render
   */
  appear: {
    type: Boolean,
    default: true,
  },
  /**
   * Transition duration in milliseconds
   */
  duration: {
    type: Number,
    default: 300,
  },
});
</script>

<style>
/* Using @apply to leverage Tailwind within the required Vue transition classes */
.slide-in-down-enter-active,
.slide-in-down-leave-active {
  @apply transition-all ease-out;
  transition-duration: v-bind('`${duration}ms`');
}

.slide-in-down-enter-from,
.slide-in-down-leave-to {
  @apply opacity-0 -translate-y-5;
}

.slide-in-down-enter-to,
.slide-in-down-leave-from {
  @apply opacity-100 translate-y-0;
}
</style>
